// extracted by mini-css-extract-plugin
module.exports = {"select":"UserSelect_select__RveLc"};